import { SystemScoreInlineType } from 'data/types';
import { getScoreBarColorClass } from './score-bar-color';
import { SCORE_CATEGORY_DEFINITIONS } from './score-category-labels';
import { getScoreNumberColor } from './score-number-color';

type SystemCategoryScoreBarsProps = Readonly<{
  score: SystemScoreInlineType | null | undefined;
}>;

export default function SystemCategoryScoreBars({
  score
}: SystemCategoryScoreBarsProps) {
  if (!score) return null;

  return (
    <div className='flex flex-col gap-1.5'>
      {SCORE_CATEGORY_DEFINITIONS.map(({ key, label }) => {
        const rawScore = score.categoryScores[key]?.score ?? 0;
        const clamped = Math.max(0, Math.min(100, rawScore));
        return (
          <div key={key} className='flex items-center gap-2'>
            <div className='w-24 shrink-0 text-[10px] text-gray-500'>
              {label}
            </div>
            <div className='relative h-1.5 w-full overflow-hidden rounded-full bg-gray-100'>
              <div
                className={`h-full rounded-full ${getScoreBarColorClass(
                  clamped
                )}`}
                style={{ width: `${clamped}%` }}
              />
            </div>
            <div
              className='w-7 shrink-0 text-right text-[10px] font-semibold'
              style={{ color: getScoreNumberColor(clamped) }}
            >
              {Math.round(clamped)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
